import type { TableColumns } from '@ohpen/enso-ui';

import type { TranslationRow } from './interfaces';

/** The top level branches of the bundle, so the filter offers exactly what is there. */
export const AREA_LIST_NAME = 'translationAreas';

export const translationColumns: TableColumns<TranslationRow> = [
  {
    title: 'config.columns.area',
    dataIndex: 'area',
    key: 'area',
    width: 160,
    options: { filter: 'select', listName: AREA_LIST_NAME, sorter: true, filterOptions: { allowedModes: ['anyMatches'] } },
  },
  {
    title: 'config.columns.key',
    dataIndex: 'key',
    key: 'key',
    width: 420,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.string',
    dataIndex: 'value',
    key: 'value',
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
];
